import { motion } from "framer-motion";
import { experience } from "../data/experience";

const Experience = () => {
  return (
    <div className="relative max-w-5xl mx-auto px-6">
      {/* vertical gradient timeline, perfectly centered within section padding */}
      <div className="absolute left-6 sm:left-7 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#00e0b7]/30 to-transparent pointer-events-none" />

      <div className="flex flex-col gap-10 relative">
        {experience.map((job, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="relative flex gap-6"
          >
            {/* glowing timeline dot */}
            <div className="flex flex-col items-center pt-2 relative z-10">
              <span className="w-3 h-3 rounded-full bg-gradient-to-r from-[#00e0b7] to-[#4b5fff] shadow-[0_0_12px_rgba(0,224,183,0.6)]" />
              {i !== experience.length - 1 && (
                <span className="w-px flex-1 bg-gradient-to-b from-[#00e0b7]/30 to-transparent" />
              )}
            </div>

            {/* experience content card */}
            <div className="flex-1 rounded-2xl bg-white/[0.02] border border-white/10 hover:border-teal-400/40 hover:shadow-[0_0_20px_rgba(0,224,183,0.15)] transition-all duration-500 p-6 md:p-8">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                <h3 className="text-lg md:text-xl font-semibold text-white">
                  {job.role}
                </h3>
                <p className="text-sm text-slate-400 mt-1 sm:mt-0">
                  {job.duration}
                </p>
              </div>

              <p className="text-slate-300 font-medium mb-3">{job.company}</p>

              <ul className="list-disc pl-5 space-y-2 text-slate-400 text-sm leading-relaxed">
                {job.highlights.map((point, j) => (
                  <li key={j}>{point}</li>
                ))}
              </ul>

              {job.tech && (
                <p className="mt-4 text-xs text-slate-500 italic border-t border-white/5 pt-3">
                  {job.tech}
                </p>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
